import type { HelpWidgetConversation } from "@/react/components/HelpWidget/types/help_widget_conversation";
import { absolutePath } from "./absolutePath";

interface HelpWidgetFnProps {
  conversation?: HelpWidgetConversation;
  conversationFilters?: {
    channel_type: "all" | "circle_bot" | "live_chat" | "email";
    status: "all" | "draft" | "closed" | "solved" | "open";
  };
  flow?: Record<string, unknown>;
  id?: string | number;
  params?: Record<string, unknown>;
  searchText?: string | number;
  spaceId?: string | number;
  target?: string;
  zendeskUploadId?: string | number;
}

export const helpWidget = {
  listConversations: ({ conversationFilters }: HelpWidgetFnProps) =>
    absolutePath("help_widget/conversations", {
      conversation: conversationFilters,
    }),
  showConversation: ({ id }: HelpWidgetFnProps) =>
    absolutePath(`help_widget/conversations/${id}`),
  createConversationDraft: ({ conversation }: HelpWidgetFnProps) =>
    absolutePath("help_widget/conversations", { conversation }),
  updateConversation: ({ id, conversation }: HelpWidgetFnProps) =>
    absolutePath(`help_widget/conversations/${id}`, { conversation }),
  createZendeskTicket: () => absolutePath("help_widget/zendesk_tickets"),
  createChat: () => absolutePath("help_widget/chats"),
  createChatMessage: ({ id }: { id: string }) =>
    absolutePath(`help_widget/conversations/${id}/messages`),
};
